'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthGrid = require('@narvar/nth-grid');

const {
  breakpointMinWidthsPx,
  WIDTH_SM
} = nthGrid.constants;
const callbackMap = new Map();
const determineIsMobile = () => {
  return typeof window === 'object' ? window.innerWidth < parseInt(breakpointMinWidthsPx[WIDTH_SM], 10) : true;
};
const handleResize = () => {
  const isMobile = determineIsMobile();
  callbackMap.forEach(callback => callback(isMobile));
};
var useIsMobile = (() => {
  const [isMobile, setIsMobile] = React.useState(determineIsMobile());
  const {
    current: id
  } = React.useRef({});

  // Effects only run on the client
  React.useEffect(() => {
    // Add the listener if this is the first one
    if (callbackMap.size === 0) {
      window.addEventListener('resize', () => handleResize());
    }
    callbackMap.set(id, () => setIsMobile(determineIsMobile()));
    return () => {
      callbackMap.delete(id);

      // Remove the listener if this is the last one
      if (callbackMap.size === 0) {
        window.removeEventListener('resize', handleResize);
      }
    };
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return isMobile;
});

exports["default"] = useIsMobile;
